<template>
  <div
    class="i-quiz-callout"
    :class="{ visible: visible }"
  >
    <span v-html="html"></span>
  </div>
</template>

<script setup>
defineProps({
  html: String,
  visible: Boolean
})
</script>

<style lang="scss" scoped>
.i-quiz-callout {
  background: #1d4ed80f;
  border-left: 3px solid $amber-mid;
  border-radius: 0 $radius $radius 0;
  padding: 14px 16px;
  margin-top: 14px;
  font-size: 13px;
  color: #1118278c;
  line-height: 1.7;
  opacity: 0;
  transform: translateY(8px);
  transition:
    opacity 0.4s 0.2s,
    transform 0.4s 0.2s;

  @include respond-to($breakpoint-md) {
    padding: 16px 20px;
    font-size: 14px;
    margin-top: 18px;
  }

  &.visible {
    opacity: 1;
    transform: none;
  }

  :deep(strong) {
    color: #111827e6;
    font-weight: 600;
  }
}
</style>
